import { Logger as y } from "@nextgen-web-framework/core";
import { getProductReqObj as f, getProductArrayReqObj as w } from "../config/productEndPoints.js";
import { logObject as P } from "../../utils/loggerUtil.js";
import { handleRequest as m } from "../../transformers/requestTransformer.js";
import { ProjectionType as u } from "../../types/enums/productEnums.js";
const g = "v1", i = y.getInstance(P("productApi")), M = {
  /**
   * @deprecated This method is deprecated. Use `getProductByIdOrError` instead for better error handling.
   */
  async getProductById({ productId: t, projections: s = u.Detailed, warehouseId: c = "", fulfillmentType: o }, n) {
    if (!t)
      throw i.error("Missing product ID. Please check arguments for a valid product ID."), new Error("Null argument. Please retry with valid product id.");
    try {
      const e = f(g, t);
      return e.params = {
        projections: s,
        warehouseId: c
      }, o && (e.params.fulfillmentType = o), await m(e, n);
    } catch (e) {
      throw i.error(`Failed to create product request object. Message: ${e}`), e;
    }
  },
  async getProductByIdOrError({
    productId: t,
    projections: s = u.Detailed,
    warehouseId: c = "",
    fulfillmentType: o,
    language: n,
    channel: e
  }, a = {}) {
    if (!t)
      throw i.error("Missing product ID. Please check arguments for a valid product ID."), new Error("Null argument. Please retry with valid product id.");
    try {
      const r = f(g, t, n, e);
      let l;
      r.params = {
        projections: s,
        warehouseId: c
      }, o && (r.params.fulfillmentType = o), a.errorHandlers = {
        default: (p) => {
          l = p;
        }
      };
      const d = await m(r, a);
      return l || d;
    } catch (r) {
      throw i.error(`Failed to create product request object. Message: ${r}`), r;
    }
  },
  async getProductByIds({
    idList: t = [],
    itemNumberList: s = [],
    variantGroupIdList: c = [],
    projections: o = u.Detailed,
    warehouseId: n = "",
    fulfillmentType: e
  }, a) {
    try {
      if ([t, s, c].every((h) => h && h.length === 0))
        throw i.error("Please check arguments"), null;
      const r = w(g);
      r.params = {
        projections: o,
        warehouseId: n
      }, e && (r.params.fulfillmentType = e);
      const l = t.toString();
      l && (r.params = {
        ...r.params,
        ids: l
      });
      const d = s.toString();
      d && (r.params = {
        ...r.params,
        itemNumbers: d
      });
      const p = c.toString();
      return p && (r.params = {
        ...r.params,
        variantGroupIds: p
      }), await m(r, a);
    } catch (r) {
      throw i.error(r), null;
    }
  },
  async getDynamicProductById({
    productId: t,
    projections: s = [
      u.ProductMin,
      u.PriceMin,
      u.InventoryMin,
      u.ItemAll
    ].join(","),
    warehouseId: c = "",
    userSegment: o = "CUSTOMER",
    fulfillmentType: n
  }, e) {
    if (!t)
      throw i.error("Missing product ID. Please check arguments for a valid product ID."), new Error("Null argument. Please retry with valid product id.");
    try {
      const a = f(g, t);
      return a.params = {
        projections: s,
        warehouseId: c,
        userSegment: o
      }, n && (a.params.fulfillmentType = n), await m(a, e);
    } catch (a) {
      throw i.error(`Failed to create product request object. Message: ${a}`), a;
    }
  }
};
export {
  M as default,
  M as productApi
};
//# sourceMappingURL=productApi.js.map
